import { cloneAuthoring } from "./authoring-json.mjs";
import { triproutesCountries } from "./triproutes-launch.mjs";

const nativeKinds=new Set(["triproutes-city-routes","triproutes-places-routes","triproutes-cities","triproutes-user-ai","triproutes-route-refinements"]);
export const hasTriproutesNativeForm=adapter=>nativeKinds.has(adapter?.kind);

export function resolveNativeSchema(schema,root) {
  if (schema?.$ref?.startsWith("#/")) {
    const resolved=schema.$ref.slice(2).split("/").reduce((value,key)=>value?.[key.replaceAll("~1","/").replaceAll("~0","~")],root);
    return resolved ? {...resolved,...Object.fromEntries(Object.entries(schema).filter(([key])=>key!=="$ref"))} : schema;
  }
  return schema || {};
}
export function nativeInitialValue(source,root=source,required=true,depth=0) {
  const schema=resolveNativeSchema(source,root);
  if(depth>12)return undefined;
  if(schema.default!==undefined)return cloneAuthoring(schema.default);
  if(schema.const!==undefined)return cloneAuthoring(schema.const);
  if(schema.oneOf || schema.anyOf)return nativeInitialValue((schema.oneOf || schema.anyOf).find(item=>item.type!=="null") || {},root,required,depth+1);
  if(!required)return undefined;
  const type=Array.isArray(schema.type)?schema.type.find(type=>type!=="null"):schema.type;
  if(type==="object" || schema.properties) return Object.fromEntries(Object.entries(schema.properties || {}).flatMap(([key,child])=>{
    const value=nativeInitialValue(child,root,schema.required?.includes(key),depth+1);return value===undefined?[]:[[key,value]];
  }));
  if(type==="array")return Array.from({length:Math.min(Number(schema.minItems || 0),50)},()=>nativeInitialValue(schema.items,root,true,depth+1));
  if(schema.enum?.length)return cloneAuthoring(schema.enum[0]);
  if(type==="boolean")return false;
  if(["number","integer"].includes(type))return schema.minimum ?? 1;
  return "";
}
export function nativeLaunchInitial(document,adapter,site="ru") {
  const value={...nativeInitialValue(document.inputSchema),...cloneAuthoring(adapter?.defaults || {})};
  if(document.inputSchema?.properties?.site)value.site=site==="app"?"app":"ru";
  if(adapter?.kind==="triproutes-route-refinements")delete value.routeId;
  if(adapter?.kind==="triproutes-places-routes" && value.mode==="single" && document.inputSchema?.properties?.places && !value.places?.length)value.places=[nativeInitialValue(document.inputSchema.properties.places.items,document.inputSchema,true)];
  return value;
}
export function countryInput(current,code,site,schema) {
  const country=triproutesCountries(site).find(country=>country.code===code);
  return {...current,countryCode:code,...(schema.properties?.country ? {country:country?.name || ""} : {})};
}

export function nativeRefinementRoute(current,route,schema) {
  if(!Number.isSafeInteger(route?.routeId) || route.routeId<1)throw new Error("Выберите маршрут из списка возвращённых на доработку.");
  const fields={routeId:route.routeId,routeName:route.name};
  const next={...current,...Object.fromEntries(Object.entries(fields).filter(([key])=>schema.properties?.[key]))};
  if(current.routeId!==undefined && String(current.routeId)!==String(route.routeId)) {delete next.feedback;delete next.additionalFeedback;}
  return next;
}
